import { useEffect } from 'react'
import { lockBodyScroll } from '@/lib/bodyScrollLock'

/**
 * While `locked`, disables page scrolling so `position: fixed` overlays stay
 * pinned to the viewport (background no longer drifts under the dim layer).
 * Restore previous `body` styles on unlock / unmount.
 */
export function useBodyScrollLock(locked: boolean) {
  useEffect(() => {
    if (!locked || typeof document === 'undefined') return
    return lockBodyScroll()
  }, [locked])
}
